import { useEffect } from "react"

import { Tabs } from "twyne-new.ui"

import { define, prop, useCraftProp } from "../../utils"
import BasePreview from "../base"

function VariantsPreview({ children, key, options, ...props }) {
  const { setValue: setOptionsValue } = useCraftProp('variant-options')
  const { value: variantValue, setValue: setVariantValue } = useCraftProp('variant')

  useEffect(() => {
    setVariantValue(options?.[0]?.value)
  }, [])

  useEffect(() => {
    setOptionsValue(options)
  }, [options, setOptionsValue])

  return <BasePreview {...props}>
    <Tabs value={variantValue} key={key}>
      {children}
    </Tabs>
  </BasePreview>
}

export default define('variants', VariantsPreview)
  .property(prop.select('Variant', 'variant').category('default').ignoreDevice(true).own()
    .props({
      options: [],
    }))
  .build()
